import * as Body from './Styles'
import { useEffect } from 'react'
const DinamoLogo = require('../../assets/images/dinamo_logo.png')

const Loading = () => { 

    useEffect(() => {
        document.body.style.overflow = 'hidden'
        return () => {
            document.body.style.overflow = ''
        }
    }, [])

    return <Body.Container>
           <div>
            <div style={{display: 'flex'}}>
                <Body.Title>
                    DHM4.0
                </Body.Title>
            </div>
            <Body.Subtitle>
                App de monitoramento
            </Body.Subtitle>
           </div>
        <Body.Logo src={DinamoLogo} />
        {window.innerWidth <= 660? <div style={{height: "20vh"}}/>:null}
    </Body.Container>
}

export default Loading